import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useState, useEffect } from "react";
import { AcademyCard, Grid, Typography, Divider, makeStyles } from "../../../../..";
import _ from "lodash";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Input, Button } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import SearchIcon from "@material-ui/icons/Search";
import InputAdornment from "@material-ui/core/InputAdornment";
var useStyles = makeStyles(function (theme) {
  return {
    tagList: {
      display: "flex",
      "flex-direction": "column"
    },
    box: {
      "border-radius": "4px",
      border: "1px solid #7d7d7d",
      display: "flex",
      "min-height": "220px",
      "flex-direction": "column",
      "justify-content": "space-between"
    },
    margin: {
      "margin-bottom": "20px",
      width: "50%"
    }
  };
});

var AcademyCoursesList = function AcademyCoursesList(_ref) {
  var courses = _ref.courses,
      translation = _ref.translation,
      props = _objectWithoutProperties(_ref, ["courses", "translation"]);

  console.log("AcademyCoursesList translation", translation);
  var classes = useStyles();

  var _useState = useState({
    tech: false,
    product: false,
    marketing: false // ideas: false,

  }),
      _useState2 = _slicedToArray(_useState, 2),
      categories = _useState2[0],
      setCategories = _useState2[1];

  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      tags = _useState4[0],
      setTags = _useState4[1];

  var _useState5 = useState(""),
      _useState6 = _slicedToArray(_useState5, 2),
      search = _useState6[0],
      setSearch = _useState6[1];

  var createTagList = function createTagList(courses) {
    var _tags = {};

    _.flatten(_.uniq(courses && courses.map(function (course) {
      return course.tags;
    }))).forEach(function (tag) {
      return _tags[tag] = false;
    });

    return _tags;
  };

  useEffect(function () {
    setTags(createTagList(courses));
  }, [courses]);

  var handleChange = function handleChange(name, type) {
    return function (event) {
      type === "category" ? setCategories(_objectSpread(_objectSpread({}, categories), {}, _defineProperty({}, name, event.target.checked))) : setTags(_objectSpread(_objectSpread({}, tags), {}, _defineProperty({}, name, event.target.checked)));
    };
  };

  var handleSearchChange = function handleSearchChange(event) {
    // console.log("event", event.target.value);
    setSearch(event.target.value);
  };

  var createFilteredCourses = function createFilteredCourses() {
    var auxCourses = courses; // console.log("auxCourses", auxCourses);
    // console.log("courses", courses);

    if (Object.keys(categories).filter(function (el) {
      return categories[el];
    }).length > 0) {
      // console.log("categories filter activated", categories);
      var _categories = Object.keys(categories).filter(function (el) {
        return categories[el];
      });

      auxCourses = auxCourses.filter(function (course) {
        return _categories.includes(course.category);
      }); // console.log("auxCourses after categories filter activated", auxCourses);
    }

    if (Object.keys(tags).filter(function (el) {
      return tags[el];
    }).length > 0) {
      // console.log("tags filter activated", tags);
      var _tags = Object.keys(tags).filter(function (el) {
        return tags[el];
      });

      auxCourses = auxCourses.filter(function (course) {
        return _.intersection(course.tags, _tags).length > 0;
      }); // console.log("auxCourses after tags filter activated", auxCourses);
    }

    if (search !== "") {
      auxCourses = auxCourses.filter(function (course) {
        return course.name.toLowerCase().includes(search.toLowerCase()) || course.description.toLowerCase().includes(search.toLowerCase());
      });
    }

    return auxCourses.sort(function (a, b) {
      if (a.name.toLowerCase() < b.name.toLowerCase()) {
        return -1;
      }

      if (a.name.toLowerCase() > b.name.toLowerCase()) {
        return 1;
      }

      return 0;
    });
  };

  return /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 11
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Academy"))), /*#__PURE__*/React.createElement(Divider, {
    style: {
      margin: "16px 0"
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2,
    md: 2,
    className: classes.tagList
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, translation ? translation.filter_by_category : "Filter by category"), categories && Object.keys(categories).map(function (category) {
    return /*#__PURE__*/React.createElement(FormControlLabel // disabled={
    //   Object.keys(tags).filter(el => tags[el]).length > 0 ||
    //   search.length > 0
    // }
    , {
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: categories[category],
        onChange: handleChange(category, "category"),
        value: category,
        color: "primary"
      }),
      label: category.toUpperCase()
    });
  }), /*#__PURE__*/React.createElement(Divider, {
    style: {
      margin: "16px 0"
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.tagList
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, translation ? translation.filter_by_tags : "Filter by tags"), tags && Object.keys(tags).map(function (tag) {
    return /*#__PURE__*/React.createElement(FormControlLabel // disabled={
    //   Object.keys(categories).filter(el => categories[el]).length >
    //     0 || search.length > 0
    // }
    , {
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: tags[tag],
        onChange: handleChange(tag),
        value: tag,
        color: "primary"
      }),
      label: tag
    });
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 10,
    md: 10
  }, /*#__PURE__*/React.createElement(FormControl, {
    className: classes.margin
  }, /*#__PURE__*/React.createElement(Input, {
    name: "search",
    value: search // disabled={
    //   Object.keys(categories).filter(el => categories[el]).length > 0 ||
    //   Object.keys(tags).filter(el => tags[el]).length > 0
    // }
    ,
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end"
    }, /*#__PURE__*/React.createElement(SearchIcon, null)),
    fullWidth: true,
    onChange: handleSearchChange
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, courses && createFilteredCourses().map(function (course) {
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      md: 4,
      lg: 4
    }, /*#__PURE__*/React.createElement(AcademyCard, Object.assign({}, course, {
      variant: "franchise"
    })));
  }))));
};

export { AcademyCoursesList as FranchiseAcademyCoursesList };